<div
  *ngIf="filterableColumns.length > 0"
  class="datatable-filter-toggle d-flex"
  [ngClass]="{ 'datatable-filter-with-warn': warningMessage != null && warningMessage !== '' }"
>
  <div class="datatable-warn-message">{{ warningMessage }}</div>
  <button
    mat-button
    class="mat-filter-button filter-toggle-button"
    color="primary"
    *ngIf="filterableColumns.length"
    (click)="toggleFilter()"
    aria-label="Filter"
  >
    <mat-icon *ngIf="!showFilters">filter_alt</mat-icon>
    <mat-icon *ngIf="showFilters">close</mat-icon>
    Filter
  </button>
  <!-- <div *ngIf="bulkEditActionTmpl && selection?.length">
    <ng-template
      *ngTemplateOutlet="bulkEditActionTmpl; context: { selected: selection }"
    ></ng-template>
  </div> -->
</div>
<div *ngIf="showFilters" class="datatable-filter-options d-flex align-items-start flex-wrap">
  <mat-form-field>
    <mat-select
      placeholder="Select Column"
      [(value)]="columnToFilter"
      [panelWidth]="null"
      panelClass="mat-select-panel"
      (selectionChange)="setFilterOperators()"
    >
      <mat-option [value]="null">-Select-</mat-option>
      <mat-option
        *ngFor="let column of filterableColumns"
        [value]="column.property"
        [disabled]="filteredColumns[column.property] === true"
      >
        {{ column.title }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="ms-2">
    <mat-form-field>
      <mat-select
        placeholder="Search Type"
        [(value)]="filterOperator"
        [panelWidth]="null"
        [disabled]="!filterOperators?.length"
        (valueChange)="filterOperatorChanged()"
      >
        <mat-option *ngFor="let operator of filterOperators" [value]="operator">
          {{ operator.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="ms-2" *ngIf="filterOperator?.requiresUserValue">
    <mat-form-field class="filter-value">
      <input
        matInput
        [(ngModel)]="filterValue"
        placeholder="Value"
        (keyup.enter)="addFilters()"
        aria-label="Column value filter"
        [disabled]="!filterOperators?.length"
        [maxlength]="filterValueMaxLength"
        [mask]="showSystemIdMask ? SYS_ID_MASK : null"
        [pattern]="showSystemIdMask ? SYS_ID_PATTERN : null"
        [placeholder]="filterPlaceholder"
      />
      <mat-hint *ngIf="filterHint">{{ filterHint }}</mat-hint>
    </mat-form-field>
    <br />
    <span
      *ngIf="invalidFilterMessage"
      class="text-warn"
      [ngClass]="{ filterErrorMessage: !filterHint }"
    >
      {{ invalidFilterMessage }}
    </span>
  </div>
  <div class="datatable-filter-tag-container" *ngIf="filterByAttributes">
    <p>{{ filterByAttributes.title }}</p>
    <mat-checkbox
      *ngFor="let value of filterByAttributes.values; let i = index"
      (change)="setCheckboxValues(i)"
      [checked]="attributeFilterCheckmarks && attributeFilterCheckmarks[i]"
    >
      {{ value }}
    </mat-checkbox>
  </div>
  <button
    mat-button
    class="mat-filter-button ms-2 me-3 dt-filter-input"
    color="primary"
    (click)="addFilters()"
    aria-label="Apply Filter"
    [disabled]="
      isInvalidFilterOption() || !isCheckboxListNullOrAllUnchecked(attributeFilterCheckmarks)
    "
  >
    Apply
  </button>
  <button
    *ngIf="defaultFilter?.length"
    mat-button
    class="mat-filter-button me-3 dt-filter-input"
    color="primary"
    (click)="resetFilters()"
    aria-label="Reset Filters"
  >
    <mat-icon [inline]="true">autorenew</mat-icon>
    Reset
  </button>
  <button
    mat-button
    class="mat-filter-button me-3 dt-filter-input"
    color="primary"
    (click)="clearFilters()"
    aria-label="Clear Active Filters"
  >
    <mat-icon [inline]="true">close</mat-icon>
    Clear
  </button>
  <mat-chip-set aria-label="List of Column Filters">
    <ng-container *ngFor="let filter of filters">
      <div class="d-flex flex-column align-items-start me-2" *ngIf="!filter.hideFromUser">
        <span class="filter-title">
          {{ filter.title }}
        </span>
        <mat-chip
          [selectable]="false"
          [removable]="true"
          [disableRipple]="true"
          (removed)="removeFilter(filter)"
          [attr.aria-label]="'Filter ' + filter.title + ' column: ' + getFilterDisplay(filter)"
        >
          {{ getFilterDisplay(filter) }}
          <button mat-icon-button color="primary" class="mat-icon-button--close" matChipRemove>
            <mat-icon>cancel</mat-icon>
            <span class="visually-hidden">Remove Filter</span>
          </button>
        </mat-chip>
      </div>
    </ng-container>
  </mat-chip-set>
</div>
